(function () {
  function init(productPage) {
    const elId = productPage.id || '';
    const sectionId = elId.replace(/^product-/, '');
    if (!sectionId) return;

    const cache = new Map();
    let lastVariantId = productPage.dataset.id || null;

    productPage.addEventListener('change', (e) => {
      const target = e.target;
      if (!target || !target.dataset || !target.dataset.variantId) return;
      const name = (target.name || '').toLowerCase();
      if (!name.includes('color') && !name.includes('colour')) return;
      const variantId = target.dataset.variantId;
      if (variantId === lastVariantId) return;
      lastVariantId = variantId;
      swap(variantId);
    });

    function swap(variantId) {
      const cached = cache.get(variantId);
      if (cached) {
        doSwap(cached);
        return;
      }

      const url = new URL(window.location.pathname, window.location.origin);
      url.searchParams.set('variant', variantId);
      url.searchParams.set('section_id', sectionId);

      fetch(url.toString())
        .then((res) => res.text())
        .then((markup) => {
          const doc = new DOMParser().parseFromString(markup, 'text/html');
          cache.set(variantId, doc);
          doSwap(doc);
        })
        .catch(() => {});
    }

    function doSwap(doc) {
      const newGallery = doc.querySelector('[data-js-product-gallery]');
      const oldGallery = productPage.querySelector('[data-js-product-gallery]');
      if (!newGallery || !oldGallery) return;
      oldGallery.replaceWith(newGallery);
      bindThumbnails(newGallery);
    }

    function bindThumbnails(gallery) {
      const slider = gallery.querySelector('css-slider');
      const thumbnails = gallery.querySelectorAll('.product-gallery__thumbnails .thumbnail');
      if (!slider || !thumbnails.length) return;

      productPage.productSlider = slider;
      productPage.productGallery = gallery;

      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('active', i === 0);
        thumb.addEventListener('click', (e) => {
          const idx = e.currentTarget.dataset.index;
          if (slider.sliderEnabled) {
            slider.changeSlide(idx);
          } else {
            const target = gallery.querySelector('.product-gallery-item[data-index="' + idx + '"]');
            if (target) {
              window.scrollTo({ top: target.getBoundingClientRect().top, behavior: 'smooth' });
            }
          }
          thumbnails.forEach((t, j) => t.classList.toggle('active', String(j) === String(idx)));
        });
      });

      slider.addEventListener('change', (e) => {
        const idx = e.target.index;
        thumbnails.forEach((t, j) => t.classList.toggle('active', j === idx));
      });
    }
  }

  function start() {
    document.querySelectorAll('product-page').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
